import React from 'react';

/**
 * Error Boundary to catch React errors and prevent app crashes
 * Shows a friendly error message instead of white screen
 * Uses plain HTML/CSS to avoid dependency on Polaris (which might be the source of errors)
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null
    });
    // Reload the app
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: '20px',
          backgroundColor: '#f6f6f7',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          <div style={{
            maxWidth: '600px',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '32px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            <h1 style={{
              fontSize: '24px',
              fontWeight: '600',
              marginBottom: '16px',
              color: '#202223'
            }}>
              Something went wrong
            </h1>
            <p style={{
              fontSize: '14px',
              color: '#6d7175',
              marginBottom: '16px',
              lineHeight: '1.5'
            }}>
              We're sorry, but something unexpected happened. Please try reloading the app.
            </p>
            {this.state.error && (
              <p style={{
                fontSize: '12px',
                color: '#8c9196',
                marginBottom: '24px',
                padding: '12px',
                backgroundColor: '#f6f6f7',
                borderRadius: '4px',
                fontFamily: 'monospace'
              }}>
                Error: {this.state.error.toString()}
              </p>
            )}
            <button
              onClick={this.handleReset}
              style={{
                backgroundColor: '#008060',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '12px 24px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#006e52'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#008060'}
            >
              Reload App
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;